import React, { Component } from "react";
import cn from "classnames";

class LoadingSpinner extends Component {
	render() {
		return (
			<div
				className={cn(
					this.props.isActive ? "loader loaderFadeIn" : ""
				)}
				style={{ display: "inline-block", opacity: "0", ...this.props.style }}
			>
				<div />
				<div />
				<div />
				<div />
			</div>
		);
	}
}

export default LoadingSpinner;
